import React, {useEffect, useState} from 'react';
import reportUtils from "../../../../../utils/report-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const AddressWithMostEvents = ({data}) => {
    const eventsByAddress = data.eventsByAddress ?? []
    const [limit, setLimit] = useState(15)
    const passedLimit = data.eventsByAddress.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 15)
    }

    const values = eventsByAddress.map(element => [
        element.qty,
        element.address,
        element.neighborhoods,
    ]);

    const labels = [
        "Quantidade",
        "Endereço",
        "Bairro"
    ]

    useEffect(() => {
        ReportUtils.createExportableTable(labels, values, 'Eventos por endereço');
    }, [data]);

    return (
        <>
            <div className="chart-report" title={"Eventos por endereço"}>
                <span id={`event-by-address-title`} className="chart-title " htmlFor={"event-by-address"} >Eventos por endereço {eventsByAddress.length > 14 ? "(TOP 15)" : "" }</span>
                <div className={"mt-3 mb-3"}>
                    <table className="table report-table" id={"event-by-address"} sheet-name="Eventos por endereço">
                        <thead className="bg-[#f2f2f2]">
                        <tr className={"text-left"}>
                            <th className={"w-[10%]"}>Qtd.</th>
                            <th className={"w-[45%]"}>Endereço</th>
                            <th className={"w-[45%]"}>Bairro</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(limit ? eventsByAddress.slice(0, limit) : eventsByAddress).map((element, index) => {
                            return(
                                <tr key={index}>
                                    <td>{element.qty}</td>
                                    <td>{reportUtils.formatText(element.address)}</td>
                                    <td>{reportUtils.formatText(element.neighborhoods)}</td>
                                </tr>
                            )
                        })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                passedLimit &&
                <div className="text-end mt-1">
                    <span id="toggle-nature" className="see-more print-hide" onClick={seeMoreOrLess}>
                        { limit ? "Ver mais" : "Ver menos" }
                    </span>
                </div>
            }
            <div className="chart-divisor"></div>
        </>
    );
};

export default AddressWithMostEvents;